/**
 * Auth role helpers — keep in sync with auth-server/app/roles.py.
 *
 * platform_super_admin — platform-wide; bypasses tenant/org gates
 * admin — tenant/org admin
 * user — internal desk
 * investor — firm-scoped portal
 */

export const PLATFORM_SUPER_ADMIN = 'platform_super_admin';
export const ADMIN = 'admin';
export const USER = 'user';
export const INVESTOR = 'investor';

export const ADMIN_ROLES = Object.freeze([PLATFORM_SUPER_ADMIN, ADMIN]);
export const INTERNAL_ROLES = Object.freeze([PLATFORM_SUPER_ADMIN, ADMIN, USER]);

export function roleOf(user) {
  const role = user?.role;
  return typeof role === 'string' ? role : null;
}

export function isPlatformSuperAdmin(user) {
  return roleOf(user) === PLATFORM_SUPER_ADMIN;
}

export function isTenantAdmin(user) {
  return roleOf(user) === ADMIN;
}

/** Elevated desk admin: platform_super_admin or tenant admin. */
export function isAdmin(user) {
  return ADMIN_ROLES.includes(roleOf(user));
}

/** Firebrand / desk users — not investor portal. */
export function isInternal(user) {
  return INTERNAL_ROLES.includes(roleOf(user));
}

export function isInvestor(user) {
  return roleOf(user) === INVESTOR;
}

/** Platform super admins may cross org/user tenant isolation gates. */
export function bypassesTenantGates(user) {
  return isPlatformSuperAdmin(user);
}

/** Only platform_super_admin may grant platform_super_admin. */
export function canAssignRole(actor, targetRole) {
  if (targetRole === PLATFORM_SUPER_ADMIN) {
    return isPlatformSuperAdmin(actor);
  }
  return true;
}
